import { useEffect, useState } from "react"
import { api } from './utils/api';
import "./styles/oderdetails.css"
import { Link, Outlet } from "react-router-dom";

function OrderItem({item}) {
  return(
    <div className='orderhis__list__item'>
      <img src={item.main_image} className="item__main-image details" alt="product" />
      <div className='item__info'>
        <div className="item__info__title">{item.title}</div>
        <div className="item__info__id">{item.id}</div>
        <div className="item__info__colorcode" style={{backgroundColor: `#${item.color.code}`}}></div>
        <div className="item__info__colorname">{item.color.name}</div>
        <div className="item__info__size">{item.size}</div>
        <div className="item__info__pricewrap">
          <div className="item__info__qty">x {item.qty}</div>
          <div className="item__info__price">TWD.{item.price}</div>
        </div>
      </div>
    </div>
  )
}

function Detail({item, setShowReview}) {
  return(
    <>
      <div className="orderDetail__header">
        <h5 className="orderDetail__title">收件地址</h5>
        <div className="orderDetail__header__name">姓名 {item.recipient.name}</div>
        <div>電話 {item.recipient.phone}</div>
        <div>地址 {item.recipient.address}</div>
        <div>email {item.recipient.email}</div>
      </div>
      <div className="orderDetail__lists">
        {item.details.map((item) => <OrderItem item={item} key={item.id}/>)}
        <h5 className="orderDetail__lists__total">訂單金額: TWD.{item.total}</h5>
      </div>
      <div className='orderDetail__footer'>
        <h5 className="orderDetail__title">付款方式</h5>
        <div>Creadit Card</div>
        <div>訂單編碼: {item.number}</div>
        <div>訂單時間: {item.time}</div>
      </div>
      {
          item.rated ? 
          <button className='rated__true orderdetail_ratedBtn' >已評價</button>
          :
          <Link to={`./review?id=${item.id}`} onClick={() => setShowReview(true)}>
            <button className='rated__false orderdetail_ratedBtn'>我要評價</button>
          </Link> 
        }
    </>
    
  )
}
export default function OrderDetails() {
  const [orderDetails, setOrderDetails] = useState([])
  const [showReview, setShowReview] = useState(false)
  useEffect(() => {
    let orderId = window.location.search.split("=")[1]
    api.getOrderList(localStorage.getItem("aws_JWT"), orderId).then((res) => {
      setOrderDetails(res.data)
    })

  }, [])
  return(
    <>
      {
        !showReview ?
        <div className="OrderDetail__wrap">
          <div className="orderDetail__finished">
            <Link to="/profile/orderhistory">
              <span className="back_icon"></span>
            </Link>
            <div>訂單已完成</div>
            <div>感謝您在STYLiSH購物!</div>
          </div>
          {orderDetails.map((item) => <Detail orderDetails = {orderDetails} item={item} key={item.id} setShowReview={setShowReview}/>)}
      </div>
      : <Outlet />
    }
    </>
    
    
  )
}